import { IterableElement } from 'type-fest'

import { Ticker } from './ticker'

export const FIAT_BALANCE_TICKERS = [Ticker.UAH]

export type FiatBalanceTicker = IterableElement<typeof FIAT_BALANCE_TICKERS>
